import { render, staticRenderFns } from "./SwiperInsert.vue?vue&type=template&id=66956346&scoped=true&"
import script from "./SwiperInsert.vue?vue&type=script&lang=js&"
export * from "./SwiperInsert.vue?vue&type=script&lang=js&"
import style0 from "./SwiperInsert.vue?vue&type=style&index=0&id=66956346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66956346",
  null
  
)

export default component.exports